import CreditsOfferInfoLabel from '../../../../../pages/vip/features/credits-offer-info-label/index';

export default CreditsOfferInfoLabel;
